import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const DeleteQuizSlice = createSlice({
    name: "deleteQuiz",
    initialState,
    reducers: {
        deleteQuizRequest(state) {
            state.loading = true;
        },
        deleteQuizRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        deleteQuizRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
        deleteQuizStateReset(state) {
            state.loading = false;
            state.error = undefined;
            state.response = undefined;
        },
    },
});

export const {
    deleteQuizRequest,
    deleteQuizRequestSuccess,
    deleteQuizRequestError,
    deleteQuizStateReset,
} = DeleteQuizSlice.actions;

export default DeleteQuizSlice.reducer;
